import ChannelMixin from '@/apps/assessment/mixins/channel-mixin'
import { SUBJECT_MAP } from '@/apps/assessment/model/common'
import { pushAuthLoginStatus } from '@/apps/courseware/model/api'
import { getCurrentUserInfo, getInitInfo, platformLogin } from '@/apps/index/models/api'
import myAssessmentRouter from '@/apps/myassessment/main'
import mineRouter from '@/apps/personal/main'
import { AssessmentAllowSubjects, ClazzAssessmentAllowSubjects } from '@/common/allow-list'
import TopmenuTrackMixin from '@/common/topmenu-track-mixin'
import CmineLogin from '@/components/enroll/CmineLogin.vue'
import { api_get } from '@/utils/http'
import { msgTip } from '@/utils/urlUtils'
import { Component, Emit, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { mapMutations } from 'vuex'
import FeedBack from '../../FeedBack.vue'
import { assessment_subjects, BLOCK_REGIONS, menu, subject_choices } from './../../model/topMenu'
import TpAppNameMixins from '@/components/common/mixins/tp-appname'
import Cookies from 'js-cookie'

const myTikuChildren = mineRouter[0].children
const myAssessmentRouterChildren = myAssessmentRouter[0].children
const REPORT_DOMAIN = process.env.VUE_APP_REPORT_DOMAIN || 'https://smartreport.test.17zuoye.net/'
const PUBLIC_MAIN_URL = process.env.VUE_APP_PUBLIC_MAIN_URL
const assessmentMenu = [
  {
    path: '/assessment/lib',
    name: '校级测评'
  },
  {
    path: '/clazz/lib',
    name: '班级测评'
  }
]
const LOGO_LIST = {
  // 缺省值
  default: {
    source: '//cdn-cnc.17zuoye.cn/fs-resource/5f966f823cb75e039db454fc.png',
    width: 89,
    height: 32
  },
  // 四川省/凉山彝族自治州/昭觉县
  '513431': {
    source: '//cdn-cnc.17zuoye.cn/fs-resource/60c96bb882393f3b375bc18a.png',
    width: 151,
    height: 32
  },
  zhonghang: {
    source: '',
    width: 89,
    height: 32,
    name: '乐知平台',
    favicon: 'https://17-pmc.oss-cn-beijing.aliyuncs.com/production/sass/1663757469963.ico'
  }
}

@Component({
  components: { FeedBack, CmineLogin }
})
export default class TopMenu extends Mixins(TopmenuTrackMixin, ChannelMixin, TpAppNameMixins) {
  private get subject_choices() {
    if (location.pathname === '/assessment' || location.pathname === '/mistake') {
      return assessment_subjects
    } else {
      return this.subjects || subject_choices
    }
  }
  private get avatar() {
    return this.curUserInfo && this.curUserInfo.avatar
  }
  private get ucenterAddress() {
    if (location.href.indexOf('test') > -1) {
      return 'https://ucenter.test.17zuoye.net/teacher/center/index.vpage'
    } else if (location.href.indexOf('staging') > -1) {
      return 'https://ucenter.staging.17zuoye.net/teacher/center/index.vpage'
    } else {
      return 'https://ucenter.17zuoye.com/teacher/center/index.vpage'
    }
  }
  private get curModule() {
    return this.$route.meta
  }
  private get curModuleName() {
    return this.$route.meta.name
  }

  // 登录弹窗
  private get getVisibleEnroll() {
    return this.$store.state.loginModal
  }
  public get curUserInfo() {
    return this.$store.state.user_info
      ? this.$store.state.user_info
      : {
          nickname: '',
          subjects: [],
          new_func_visited: 1,
          avatar: '',
          regions: []
        }
  }
  // 中行用户
  private get isZhongHang() {
    return (
      this.curUserInfo &&
      this.curUserInfo.customer_ids &&
      this.curUserInfo.customer_ids.includes(this.zhongHangId)
    )
  }
  public get doNotShowMistake() {
    return this.notShowMistake
  }
  public get getfeedbackStatus() {
    return this.$store.state.feedbackStatus
  }
  // 本地没有subject的情况下为101，本地有subject情况下为本地subject，重新登录会重置为默认subject
  public get subject() {
    return this.$store.state.subject
  }
  private get assessmentPermission() {
    let section =
      this.curUserInfo &&
      this.curUserInfo.regions &&
      this.curUserInfo.regions.length > 0 &&
      this.curUserInfo.regions[2]
    let a = AssessmentAllowSubjects.map((n) => n.value).includes(this.subject.value)
    let b = this.curUserInfo.subjects.map((n) => n[0]).includes(this.subject.value)
    let c = section && BLOCK_REGIONS.includes(String(section.code))
    let zhonghang =
      this.curUserInfo.customer_ids && this.curUserInfo.customer_ids.includes(this.zhongHangId)
    return a && b && !c && !zhonghang
  }
  private get logoSource() {
    let section =
      this.curUserInfo &&
      this.curUserInfo.regions &&
      this.curUserInfo.regions.length > 0 &&
      this.curUserInfo.regions[2]
    if (section && section.code) {
      console.log(section.code)
      if (LOGO_LIST[String(section.code)]) {
        return LOGO_LIST[String(section.code)]
      } else if (this.isZhongHang) {
        return LOGO_LIST['zhonghang']
      } else {
        if (this.tpAppLogo) {
          return this.tpAppLogo
        }
        return LOGO_LIST.default
      }
    } else {
      if (this.isZhongHang) {
        return LOGO_LIST['zhonghang']
      } else {
        if (this.tpAppLogo) {
          return this.tpAppLogo
        }
        return LOGO_LIST.default
      }
    }
  }
  private get isBlockSection() {
    let section =
      this.curUserInfo &&
      this.curUserInfo.regions &&
      this.curUserInfo.regions.length > 0 &&
      this.curUserInfo.regions[2]
    return section && BLOCK_REGIONS.includes(String(section.code))
  }

  @Prop() public showSubject?: boolean
  @Prop() public noPick?: boolean
  @Prop() public nomenu?: boolean
  @Prop() public assessment?: boolean
  public feedbackModal = false
  public feedbackStatus = false
  public notShowMistake = true
  // 临时添加登录
  public visibleEnroll = false
  public currentTab = 1
  // 增加可切换的学科
  public currentSubject: any = '加载中...'
  public down = true
  public subjects: any[] = []
  public uid = ''
  public tiuid = ''
  public modalContext = '您同时用了两个不同账号登录，请刷新页面'
  public visible = false
  public assessmentMenu = assessmentMenu

  private myTikuDropDownMenu = myTikuChildren
  private menu = menu

  private myAssessmentRouterChildren = myAssessmentRouterChildren
  private zhongHangId = 'd5bf4a5ff8876b0f0b5a53f91b65c43a' // 中行用户

  @Watch('getVisibleEnroll')
  public onLoginModalChange(val: any) {
    this.visibleEnroll = val
  }
  // 课件新手指引
  public async changeVisited() {
    const res: any = await pushAuthLoginStatus({
      status: 1
    })
    if (res.success) {
      const tag: any = document.getElementsByClassName('mask')[0]
      const maskTag: any = document.getElementsByClassName('mask-box')[0]
      tag.style.display = 'none'
      maskTag.style.display = 'none'
      this.getUserDetail()
    }
  }
  public async goPlatForm() {
    try {
      let data: any = await platformLogin({ withCredentials: true })
      // console.log(data.data)
      if (data.data.success) {
        this._get()
        this._set(this.uid, 30) // cookie插入一个tiuid,用于保存uid进行周期性比对
        window['sensors'].login(this.uid)
        this.getUserDetail()
        this.checkUid()
        this.$store.commit('SET_PLATFORMLOGIN', {})
      } else {
        this.getUserDetail()
        this._set('', -1)
      }
    } catch (e) {
      this.getUserDetail()
    }
  }
  // 通过周期性比较tiuid 和 uid 来
  public _set(tiuid, num) {
    const time: any = new Date()
    time.setTime(time.getTime() + 24 * 60 * 60 * 1000 * num)
    window.document.cookie = `tiuid=${tiuid}; path=/; expires=${time.toGMTString()}`
  }
  // get
  public _get() {
    if (document.cookie.length > 0) {
      const cookieArr1 = document.cookie.split(';')
      for (let i in cookieArr1) {
        const cookieArr2 = cookieArr1[i].split('=')
        cookieArr2[0] = cookieArr2[0].replace(/\s+/g, '')
        cookieArr2[1] = cookieArr2[1].replace(/\s+/g, '')
        if (cookieArr2[0] === 'uid') {
          this.uid = cookieArr2[1]
        } else if (cookieArr2[0] === 'tiuid') {
          this.tiuid = cookieArr2[1]
        }
      }
    }
  }
  // 获取userInfo
  public async getUserDetail() {
    try {
      let d: any = await getCurrentUserInfo({})
      if (d.success) {
        let groupLeaderSubject = []
        this.$store.commit('SET_USER_INFO', d.data)
        // 获取默认学科
        let subject = d.data.subjects.map((item) => {
          const nick = SUBJECT_MAP[item[0]]
          return {
            label: item[1],
            value: item[0],
            nick
          }
        })
        groupLeaderSubject = d.data.subjectLeaders || []
        // result 是该教师所有学科中的学科组长学科
        let result: any[] = []
        groupLeaderSubject.forEach((item: any) => {
          for (let n of subject) {
            if (item && item.subject === n.nick) {
              n.clazzLevels = item.clazzLevels
              result = [...result, n]
            }
          }
        })
        // 获取学科组长学科，并进行过滤
        let final: any[] = []
        AssessmentAllowSubjects.forEach((item: any) => {
          for (let n of result) {
            if (item && item.value === n.value) {
              final = [...final, n]
            }
          }
        })
        let final2: any[] = []
        ClazzAssessmentAllowSubjects.forEach((item: any) => {
          for (let n of subject) {
            if (item && item.value === n.value) {
              final2 = [...final2, n]
            }
          }
        })

        this.$store.commit('SET_SUPPORT_SUBJECTS', final)
        this.$store.commit('SET_CLAZZ_SUPPORT_SUBJECTS', final2)
        if (!this.subject || !this.subject.value) {
          if (subject && subject.length > 0) {
            this.$store.commit('SET_SUBJECT', subject[0])
          } else {
            this.$store.commit('SET_SUBJECT', {
              label: '小学语文',
              value: 101,
              nick: 'CHINESE'
            })
          }
        }
      } else {
        this.$store.commit('SET_SUBJECT', {
          label: '小学语文',
          value: 101,
          nick: 'CHINESE'
        })
      }
      this.currentSubject = this.subject.label
      this.getBaseInfo(this.subject.value)
      this.$emit('subject', this.subject.label)
      this.register()
    } catch (e) {
      this.currentSubject = this.subject.label
      this.getBaseInfo(this.subject.value)
      this.$emit('subject', this.subject.label)
      this.register()
    }
  }
  @Watch('getfeedbackStatus', { deep: true })
  public onGetfeedbackStatusChange(val) {
    if (this.feedbackModal) {
      this.onOpenFeedback()
    } else {
      this.feedbackModal = true
      setTimeout(() => {
        this.onOpenFeedback()
        this.feedbackModal = false
      }, 0)
    }
  }
  @Watch('curUserInfo')
  public onUserChange(val) {
    if (val && val.regions && val.regions.length > 0) {
      let section = this.curUserInfo.regions[2]
      if (section && BLOCK_REGIONS.includes(String(section.code))) {
        this.changeFavicon()
        this.changeTitle()
      }
    }
  }
  public onOpenFeedback() {
    this.feedbackStatus = true
    this.trackMenu('我要反馈')
  }
  public onCloseFeedback() {
    this.feedbackStatus = false
  }
  public async getBaseInfo(val) {
    let xx: any = {
      label: '小学',
      subs: []
    }
    let cz: any = {
      label: '初中',
      subs: []
    }
    let gz: any = {
      label: '高中',
      subs: []
    }
    let grades = {
      name: '年级：',
      label: 'grade',
      val: []
    }
    let sections = {
      name: '地区：',
      label: 'section',
      val: [{ name: '全部', val: 0 }]
    }
    let years = {
      name: '年份：',
      label: 'year',
      val: []
    }
    let origins: any = {
      name: '类型：',
      label: 'sort_way',
      val: []
    }
    try {
      let { data, success }: any = await getInitInfo({
        subject_id: val
      })
      this.notShowMistake = data.do_not_show
      for (let n of data.subject_choices) {
        const nick = SUBJECT_MAP[n[0]]
        if (/^1\d{2}$/.test(n[0])) {
          xx.subs.push({
            label: n[1],
            value: n[0],
            nick
          })
        } else if (/^2\d{2}$/.test(n[0])) {
          cz.subs.push({
            label: n[1],
            value: n[0],
            nick
          })
        } else if (/^3\d{2}$/.test(n[0])) {
          gz.subs.push({
            label: n[1],
            value: n[0],
            nick
          })
        }
      }
      this.subjects = [xx, cz, gz]
      grades.val = data.grade_choices.map((n) => {
        return {
          name: n[1],
          val: n[0]
        }
      })
      let region_choices = data.region_choices.map((n) => {
        return {
          name: n.name,
          val: n.code
        }
      })
      sections.val = [{ name: '全部', val: 0 }, ...region_choices]
      years.val = data.year_choices.map((n) => {
        return {
          name: n[1],
          val: n[0]
        }
      })
      let paper_type_choices = data.paper_type_choices.map((n) => {
        return {
          name: n[1],
          val: n[0]
        }
      })
      origins.val = [{ name: '全部', val: 0 }, ...paper_type_choices]
      this.$store.commit('SET_DOWNLOAD_AUDIO_TYPES', data.download_audio_types)
      this.$store.commit('SET_ALLRULES', [grades, sections, years, origins])
      this.$store.commit('SET_GRADES', [grades, sections, years, origins])
    } catch (e) {
      console.log(e)
    }
  }
  // 点击退出
  public async logoutHandler() {
    let rdata = await api_get('/api/auth/logout', {})
    if (rdata.success) {
      msgTip({
        type: 'success',
        msg: rdata.msg
      })
      Cookies.remove('TP_AppName')
      Cookies.remove('TP_AppName', { path: '' })
      if (this.isBlockSection) {
        const TO = PUBLIC_MAIN_URL
          ? PUBLIC_MAIN_URL + '/project/liangshan/login.vpage'
          : 'https://www.test.17zuoye.net/project/liangshan/login.vpage'
        this.$store.commit('SET_USER', { name: null })
        this.$store.commit('SET_USER_INFO', undefined)
        location.href = TO
      } else {
        // logout logic
        this.$store.commit('SET_USER', { name: null })
        this.$store.commit('SET_USER_INFO', undefined)
        window.location.href = '/'
      }
    } else {
      msgTip({
        type: 'error',
        msg: rdata.error || 'error'
      })
    }
  }
  public selectSubject(item) {
    this.currentSubject = item.label
    this.$store.commit('SET_SUBJECT', item)
    this.getBaseInfo(item.value)
    this.register()
  }
  public created() {
    this.getUserDetail()
  }
  public mounted() {
    window.onresize = () => {
      this.getDomBoundingClientRect()
    }
    this.getDomBoundingClientRect()
    this.checkUid()
  }
  public getDomBoundingClientRect() {
    const temp: any = document.getElementsByClassName('tkn-tab-course')[0]
    const target: any = document.getElementsByClassName('mask-box')[0]
    if (!target) return
    target.style.left = temp.getBoundingClientRect().left - 67 + 'px'
  }
  public sign() {
    // this.visibleLogin = true
    this.visibleEnroll = true
    this.currentTab = 1
    window['sensors'].track('Head_buttonClick', { buttonName: '登录按钮' })
  }
  public enrollHandler() {
    this.currentTab = 2
  }
  public loginHandler() {
    this.currentTab = 1
  }
  public giveVipPresentHandler() {
    this.currentSubject = this.subject.label
    this.$emit('subject', this.subject.label)
    this.getBaseInfo(this.subject.value)
    this.onCancel()
    this.checkUid()
    this.register()
  }
  public onCancel() {
    this.visibleEnroll = false
  }
  public checkUid() {
    let tid = setInterval(() => {
      this._get()
      if (this.tiuid && this.uid) {
        if (this.tiuid != this.uid) {
          clearInterval(tid)
          this.$info({
            title: '您同时用了两个不同账号登录，请刷新页面',
            okText: '知道了',
            keyboard: false,
            onOk: () => location.reload(),
            onCancel: () => location.reload()
          })
        }
      }
    }, 2000)
  }
  public handleCancel() {
    this.visible = false
    // this.goPlatForm()
    setTimeout(() => {
      location.reload()
    }, 1000)
  }
  // 控制tab显示
  // tslint:disable-next-line:cyclomatic-complexity
  public allowTab(item) {
    this.$nextTick(() => {
      this.getDomBoundingClientRect()
    })
    let section =
      this.curUserInfo &&
      this.curUserInfo.regions &&
      this.curUserInfo.regions.length > 0 &&
      this.curUserInfo.regions[2]
    if (item.name === 'checkSource') {
      if (!(section && BLOCK_REGIONS.includes(String(section.code)))) {
        return false
      }
    }
    if (item.name === 'assessment' || item.name === 'mistake') {
      if (item.name === 'assessment' && section && BLOCK_REGIONS.includes(String(section.code))) {
        return false
      }
      if (
        item.meta.allowSubjects.includes(this.subject.value) &&
        this.curUserInfo &&
        this.curUserInfo.subjects &&
        this.curUserInfo.customer_ids &&
        !this.curUserInfo.customer_ids.includes(this.zhongHangId) // d5bf4a5ff8876b0f0b5a53f91b65c43a 中行用户
      ) {
        return true
      } else {
        return false
      }
    }
    if (
      item.meta.allowSubjects === 'all' ||
      item.meta.allowSubjects.indexOf(this.subject.value) > -1
    ) {
      if (item.meta.section === '校级测评') {
        if (
          this.curUserInfo &&
          this.curUserInfo.subjectLeaders &&
          this.curUserInfo.subjectLeaders.length > 0
        ) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  }
  // 点击注册按钮
  public onRegisterClick(e) {
    window['sensors'].track('Head_buttonClick', { buttonName: '注册按钮' })
    setTimeout(() => {
      window.open('/register')
    }, 200)
    e.preventDefault()
  }
  // 点击我的题库下拉
  public onDropDownMenuClick(item) {
    this.trackMenu(item.meta.label)
    if (item.meta.name === 'report') {
      window.open(REPORT_DOMAIN + '/vox-17xue/groupReport')
    } else {
      setTimeout(() => {
        location.href = item.path
      }, 200)
    }
  }
  private selectItem(item: any) {
    this.trackMenu(item.meta.name) // 导航栏打点
    if (!(this.curUserInfo && this.curUserInfo.nickname)) {
      // this.$store.commit('SET_PLATFORMLOGIN', {})
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    if (item.name === 'checkSource') {
      setTimeout(() => {
        const nick = this.subject && this.subject.nick
        const extra = this.subject && SUBJECT_MAP[this.subject.value]
        const path = item.path // 跳转去掉学科
        window.open(path)
      }, 100)
      return
    }
    if (item.path.indexOf('assessment') > -1) {
      if (item.meta.useType.indexOf(Number(this.curUserInfo.user_type)) > -1) {
        this.$store.commit('SET_ASSESSMENT_MODAL_STATUS', {})
      } else {
        setTimeout(() => {
          location.replace(item.path)
        }, 100)
      }
    } else {
      setTimeout(() => {
        location.replace(item.path)
      }, 100)
    }
  }
  private register() {
    let regions = this.curUserInfo && this.curUserInfo.regions
    let _province = regions && regions.length > 0 ? regions[0].name : '未知'
    let _city = regions && regions.length > 1 ? regions[1].name : '未知'
    let _area = regions && regions.length > 2 ? regions[2].name : '未知'
    const env = process.env.VUE_APP_MODE || 'development'
    const channel = this.SAchannel

    setTimeout(() => {
      window['sensors'].registerPage({
        platform: 'Web',
        product: '内容库',
        subject: String(this.subject.value) || undefined,
        _province,
        _city,
        _area,
        env,
        channel
      })
    }, 50)
  }
  private getPopupContainer() {
    return document.getElementById('dropDownContainer')
  }
  private openNewTab() {
    window.open('/assessment/lib')
  }
  // 点击校级测评的下拉菜单
  private onAssessmentMenuClick(item) {
    window.open(item.path)
  }
  // 修改favicon
  private changeFavicon() {
    let link: any = document.querySelector("link[rel*='icon']") || document.createElement('link')
    let VERSION = process.env.VUE_APP_VERSION
    let CDN_URL = process.env.VUE_APP_CDN_URL || '//cdn-cnc.test.17zuoye.net/s17/ti/'
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = CDN_URL + VERSION + '/liangshan/favicon.ico'
    console.log(link.href)
    document.getElementsByTagName('head')[0].appendChild(link)
  }
  // 修改title
  private changeTitle() {
    document.title = '四川省民族地区资源平台'
  }
}
